import { createGlobalStyle } from 'styled-components'
import { COLORS } from '@probatix/common/constants/colors'
import { MAX_SMALL_DESKTOP, MOBILE_WIDTH } from '@probatix/common/constants/design'
import 'bootstrap/dist/css/bootstrap.min.css'

interface IGlobalStyled {
  authenticated: boolean
}

// if you have any scroll issue on mobile, please check  #root  // overflow-y
export const GlobalStyled = createGlobalStyle<IGlobalStyled>`
  :root {
    --rsbs-backdrop-bg: rgba(0, 0, 0, 0.1);
    --rdp-background-color: ${COLORS.BLUE};
  }

  *, *:after, *:before {
    box-sizing: border-box;
  }

  html, body {
    top: 0px !important;
    min-height: 100vh !important;
    background: #FBFBFB;
    min-width: 320px;
    
    // make unscrollable for private pages on mobile
    ${(props) => (!!props.authenticated && `@media(max-width: ${MAX_SMALL_DESKTOP}px) {  overflow: hidden;  }`)}
    
    @media(max-width: ${MOBILE_WIDTH}px) {
      background: #FFF !important;
      min-width: 100%;
    }
  }

  #root {
    min-height: 100vh;
    background: #FBFBFB;
    overflow-y: auto; 
  }
  
  html, body, button {
    font-family: 'Figtree';
  }
  
  p {
    margin: 0;
    padding: 0;
  }

  h1 {
    line-height: 1.3em
  }
  
  a {
    color: ${COLORS.BLUE_LIGHT};
    text-decoration: none;
    transition: .2s;
    font-weight: 700;

    &:hover {
      color: ${COLORS.BLUE_LIGHT};
    }
  }

  [data-vaul-handle] {
    background-color: transparent !important;
    max-height: 90%;
  }

  [vaul-drawer-wrapper] {
    background-color: white !important;
  }

  [data-rsbs-content] {
    padding: 10px;
  }

  [data-rsbs-footer] {
    box-shadow: none;
  }

  [class*="Snackbar_snackbar-wrapper"] {
    z-index: 100 !important;
  }

  [data-rsbs-overlay],
  [data-rsbs-backdrop],
  [data-rsbs-root]:after {
    z-index: 15;
  }
`
